module.exports = __webpack_public_path__ + "img/car-B-2.ab9a511b.jpg";